/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function EmptyErrorImpl() {
    Error.call(this);
    this.message = 'no elements in sequence';
    this.name = 'EmptyError';
    return this;
}
EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
export var EmptyError = EmptyErrorImpl;
//# sourceMappingURL=EmptyError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/EmptyError.js
// module id = 2563
// module chunks = 1